'use strict';

angular.module('directives.autoHeight', [])

.directive('autoHeightParent', function($window) {
    return {
        controller: function($scope) {
            var registeredSiblings = [];
            this.registerSibling = function(siblingElement) {
                registeredSiblings.push(siblingElement);
            }
            this.getSiblings = function () {
                return registeredSiblings;
            }
        }
    };
})

.directive('autoHeightSibling', function() {
    return {
        require: '^autoHeightParent',
        link: function link(scope, iElement, iAttrs, parentController) {
            parentController.registerSibling(iElement);
        }
    };
})

.directive('autoHeight', ['$window', '$timeout', function ($window, $timeout) {
    return {
        require: '^autoHeightParent',
        link: function ($scope, $element, $attrs, parentController) {
            var maxHeights = function (collection) {
                var heights, node, _i, _len, height;
                var toMax = 0;
                for (_i = 0, _len = collection.length; _i < _len; _i++) {
                    node = collection[_i];
                    height = node.outerHeight();
                    if (height > toMax) toMax = height;
                }
                return toMax;
            };
            angular.element($window).bind('resize', function () {
                return $element.css('height', maxHeights(parentController.getSiblings()));
            });
            return $timeout(function () {
                return angular.element($window).triggerHandler('resize');
            }, 1000);
            }
        };
    }
]);
